import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { parseFaq, renderInline } from "../lib/richText";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Watermark, Eyebrow } from "../components/Botanical";

export default function FAQ() {
  const [faq, setFaq] = useState(null);
  useEffect(() => {
    api.get("/policies/faq").then((r) => setFaq(parseFaq(r.data.body_md))).catch(() => setFaq([]));
  }, []);

  return (
    <div className="relative overflow-x-clip" data-testid="faq-page">
      <Watermark opacity={0.25} height="h-[240px] sm:h-[280px]" testid="faq-watermark" />
      <div className="relative max-w-3xl mx-auto px-6 py-16 sm:py-20">
        <Eyebrow>Help</Eyebrow>
        <h1 className="font-serif text-4xl sm:text-5xl mt-2 mb-10">Frequently Asked Questions</h1>
        {faq === null && <p className="text-[#5E4D5A]">Loading…</p>}
        <Accordion type="multiple" className="rounded-2xl bg-white/80 border border-[#D8CDBC] px-5 sm:px-8">
          {(faq || []).map((item, i) => (
            <AccordionItem key={item.q} value={`q${i}`} className="border-[#D8CDBC] last:border-b-0" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-serif text-lg sm:text-xl text-[#5A433B] py-5 hover:no-underline hover:text-[#59394F]" data-testid={`faq-trigger-${i}`}>
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-[#5E4D5A] leading-relaxed space-y-3" data-testid={`faq-answer-${i}`}>
                {item.a.map((para, j) => <p key={j}>{renderInline(para)}</p>)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
